export const clientListSelector = (state) => state.client.list;
export const clientSelector = (state) => state.client.current;
export const errorSelector = (state) => state.client.error;
export const agreementsListSelector = (state) => state.client.agreementsList;
export const organizationsListSelector = (state) => state.client.organizationsList;
export const clientInterestSelector = (state) => state.client.clientInterest;
export const docTypeListSelector = (state) => state.client.docTypeList;
